<script>
    import RoleEditHeader from '@/components/page-user-edit/role-edit/RoleEditHeader.vue';
    import RoleEditData from '@/components/page-user-edit/role-edit/RoleEditData.vue';

    export default {
        computed: {
            isShowRoleEdit() {return this.$store.getters.IS_SHOW_ROLE_EDIT},
        },
        components: {
            RoleEditHeader: RoleEditHeader,
            RoleEditData: RoleEditData,
        }
    }
</script>


<template>
    <div
        v-if="isShowRoleEdit"
        class="left_additional_container"
    >
        <RoleEditHeader />
        <hr class="hr_light_98">
        <RoleEditData />
    </div>
</template>